const ALL_API = { // 根据条件获取礼品卡组列表
  // 状态@0=待审核；1=审核通过; 2=审核拒绝; 3=已激活; 4=已作废;
  listGiftcardGroup: {
    method: 'get',
    url: '/api/giftcard/listGiftcardGroup'
  },
  // 获取会员礼品卡列表
  listMemberGiftcard: {
    method: 'get',
    url: '/api/wechat/listMemberGiftcard'
  },
  // 礼品卡充值
  giftcardRecharge: {
    method: 'post',
    url: '/api/wechat/giftcardRecharge'
  }
}

export default ALL_API



// WEBPACK FOOTER //
// ./src/api/giftcard/index.js